import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session'; // Use session storage

import quoteResponseReducer from './reducers';
import bookingReducer from './reducers/bookingReducer';
import customerBookingReducer from './reducers/customerBookingReducer';
import travelDetailsReducer from './reducers/travelDetailsReducer';
import loginResponseReducer from './reducers/loginResponseReducer';
import createBookingReducer from './reducers/createBookingReducer';
import recordPaymentReducer from './reducers/recordPaymentReducer';
import privelegedResponseReducer from './reducers/privelegedAccountReducer';
import selectedDestination from './reducers/selectedDestinationReducer';
import selectedDropOff from './reducers/selectedDropOffReducer';
import mixedProductreducer from './reducers/mixedProductReducer';
import gtmReducer from './reducers/gtmReducer';
import createIntentReducer from './reducers/createIntentReducer';
import promoCode from "./reducers/setPromoCode";
import systemSettings from './reducers/setSystemSettings';


const rootReducer = combineReducers({
  quoteResponse: quoteResponseReducer,
  booking: bookingReducer,
  customer: customerBookingReducer,
  travelDetails: travelDetailsReducer,
  loginResponse: loginResponseReducer,
  createBooking: createBookingReducer,
  recordPayment: recordPaymentReducer,
  priveleged: privelegedResponseReducer,
  selectedDestination,
  promoCode: promoCode,
  selectedDropOff,
  mixedProduct: mixedProductreducer,
  gtm: gtmReducer,
  createIntent: createIntentReducer,
  systemSettings: systemSettings,
});

// Define the persist configuration for the state slices you want to persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['createBooking', 'travelDetails', 'quoteResponse','booking', 'createIntent', 'promoCode'], // Specify which slices of state you want to persist
};

// Wrap the rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
